import React from 'react';
import { H5Text } from '../../../../styles/AvantTypography';

export function PendingProctorSetup() {
    return <H5Text>Pending Proctor Setup</H5Text>
}
